"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRow = void 0;
class TableRow {
    x;
    constructor(x) {
        this.x = x;
    }
}
exports.TableRow = TableRow;
